// src/components/payment/PaymentTimer.jsx
// Countdown timer for QR code expiry

import { useState, useEffect } from "react";

export default function PaymentTimer({ expiresAt, onExpired }) {
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    if (!expiresAt) return;

    const expiry = new Date(expiresAt).getTime();

    const tick = () => {
      const remaining = Math.max(0, Math.floor((expiry - Date.now()) / 1000));
      setSecondsLeft(remaining);
      if (remaining <= 0 && onExpired) onExpired();
    };

    tick(); // run immediately
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [expiresAt]);

  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const pct = expiresAt
    ? Math.max(0, (secondsLeft / (15 * 60)) * 100)
    : 100;

  const isUrgent = secondsLeft < 60;
  const color = isUrgent ? "#ff6b6b" : secondsLeft < 180 ? "#fbbf24" : "#00d4ff";

  return (
    <div style={{ textAlign: "center" }}>
      {/* Circular progress */}
      <div style={{ position: "relative", display: "inline-block", marginBottom: 8 }}>
        <svg width="64" height="64" style={{ transform: "rotate(-90deg)" }}>
          {/* Background circle */}
          <circle
            cx="32" cy="32" r="26"
            fill="none"
            stroke="rgba(255,255,255,0.06)"
            strokeWidth="4"
          />
          {/* Progress circle */}
          <circle
            cx="32" cy="32" r="26"
            fill="none"
            stroke={color}
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray={`${2 * Math.PI * 26}`}
            strokeDashoffset={`${2 * Math.PI * 26 * (1 - pct / 100)}`}
            style={{ transition: "stroke-dashoffset 1s linear, stroke 0.5s" }}
          />
        </svg>
        <div style={{
          position: "absolute", inset: 0,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontFamily: "'Oxanium', sans-serif",
          fontSize: 13, fontWeight: 700,
          color,
        }}>
          {String(minutes).padStart(2, "0")}:{String(seconds).padStart(2, "0")}
        </div>
      </div>

      <div style={{
        fontFamily: "'DM Mono', monospace",
        fontSize: 11, color: isUrgent ? "#ff6b6b" : "#556",
        letterSpacing: "1px",
        animation: isUrgent ? "urgentPulse 1s ease infinite" : "none",
      }}>
        {secondsLeft <= 0 ? "QR EXPIRED" : "QR EXPIRES IN"}
      </div>

      <style>{`
        @keyframes urgentPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
}